import { render, staticRenderFns } from "./ClientNotificationListPopup.vue?vue&type=template&id=5c79551a&scoped=true&"
import script from "./ClientNotificationListPopup.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c79551a",
  null
  
)

export default component.exports